var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Dot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 14C11.375 15.4472 12.5527 16.625 14 16.625C15.4472 16.625 16.625 15.4472 16.625 14C16.625 12.5527 15.4472 11.375 14 11.375C12.5527 11.375 11.375 12.5527 11.375 14Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 22.75C11.375 24.1972 12.5527 25.375 14 25.375C15.4472 25.375 16.625 24.1972 16.625 22.75C16.625 21.3027 15.4472 20.125 14 20.125C12.5527 20.125 11.375 21.3027 11.375 22.75Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 5.25C11.375 6.69725 12.5527 7.875 14 7.875C15.4472 7.875 16.625 6.69725 16.625 5.25C16.625 3.80275 15.4472 2.625 14 2.625C12.5527 2.625 11.375 3.80275 11.375 5.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dot);
export default __webpack_public_path__ + "static/media/3-dot.902756296de5f6ba6bcee3c18a12649b.svg";
export { ForwardRef as ReactComponent };